import React, { useEffect, useState, useRef } from 'react';
import { Link } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../elements/RenderErrors';
import InputTextArea from '../elements/InputTextArea';
import ButtonGroupSelection from '../elements/ButtonGroupSelection';
import store from '../../services/store';
import helpers from '../../services/helpers';
import { getApiData, postApiData } from '../../services/apiService';
import Swal from 'sweetalert2';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
 
export default function CancelItemsFormModal ({
        reference_id = '', 
        is_show = false, 
        setShow, 
        handleSave, 
        header_title="Cancel Items",
        origin="customer",
        store_id="",
        index="",
        member_data={},
        direct_save
    }){
    let default_data = {
        "id": "",
        "name":"",
        "relationship":"",
        "gender":"",
        "age":"",
        "flag":"new"
    }
    const toast = useRef(null);
    const [loading, setLoading] = useState(1);
    const [notice, setNotice] = useState('');
    const [record_data, setRecordData] = useState([]);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [data_table, setDataTable] = useState([]);
    const [is_checked, setChecked] = useState(false);
    const [errors, setErrors] = useState([]);
   
    useEffect(() => {
        setErrors([])
        
        if(is_show) {
            fetchData()
        }
        setChecked(false)
    }, [is_show]);
   
    useEffect(() => {
        setErrors([])
        displayDataTable(record_data)
    }, [record_data]);
    

    async function fetchData(){
        if(!reference_id){
            return
        }
        setLoading(1)

        const endpoint = helpers.createUrl(`V1/manage/order/sales/${reference_id}`)
        const res = await getApiData(endpoint, false)

        if(res.status === 'error'){
            toast.current.show({severity:'error', detail:res.message, life: 10000});
            setLoading(0)
        }
        else{
            setLoading(0)

            if(hasCancelledQuantity(res.items)){
                toast.current.show({severity:'error', detail:'Some ordered items are already cancelled.', life: 20000});
                reset();
                setShow(0);
            }
            setRecordData(updateCancelledQuantity(res.items))
        }
    }

    function updateCancelledQuantity(items) {
        return items.map(item => {
            const quantity = Number(item.quantity) || 0;
            const fulfilled = Number(item.fulfilled_quantity) || 0;

            return {
            ...item,
            cancelled_quantity: Math.max(quantity - fulfilled, 0)
            };
        });
    }

        function hasCancelledQuantity(items) {
            return items.some(item => parseFloat(item.cancelled_quantity) > 0);
        }

        function inputItemChange(val, id) {
            const updated_data = helpers.updateItemInState(record_data, {"id": id,"cancelled_quantity": val})

            setRecordData(updated_data)
        }

        function removeItem(id){
            if(record_data.length === 1) {
                toast.current.clear();
                toast.current.show({severity:'error', detail:'Please select at least one (1) item to return.', life: 20000});
                return
            }
            else{
                const idx = helpers.isObjectExistIndex(record_data, id)
                if(idx!==null){
                    let items = [...record_data]
                    items.splice(idx, 1); 

                    setRecordData(items)
                }
            }

        }
    
        function displayDataTable(data){
            setDataTable(
                <DataTable 
                    className='border-top'
                    dataKey={data?.id}
                    value={data} 
                    // tableStyle={{ minWidth: '50rem' }}
                    size="small"
                    lazy
                    scrollHeight="300px"
                    scrollable
                    responsive={true}
                    emptyMessage="No data to display"
                >
                    <Column header="ITEM DETAILS" body={({product_name, product_description}) => {
                        return (<>
                            <p className='mb-0'>{product_name}</p>
                            <small>{product_description}</small>
                        </>)
                    }}/>
                    <Column field="quantity" header="QUANTITY ORDERED" ></Column>
                    <Column field="fulfilled_quantity" header="QUANTITY FULFILLED" ></Column>
                    <Column header="QUANTITY TO CANCEL" body={({cancelled_quantity, quantity, fulfilled_quantity, id}) => 
                        <InputNumber
                            id="cancel_quantity" 
                            name="cancel_quantity" 
                            className="cancel-input"
                            inputStyle={{ minWidth: '50px', maxWidth: '200px' }}
                            value={cancelled_quantity}
                            tagClass="mb-0"
                            onValueChange={(e) => inputItemChange(e.value, id)}
                            placeholder="Quantity"
                            min={0}
                            max={Number(quantity - fulfilled_quantity)}
                        />
                    }/>
                    <Column body={({id}) => <button className='btn btn-dangers p-0' type="button" onClick={(e) => removeItem(id)} disabled={record_data.length === 1}><i className="fa fa-times-circle text-danger"></i></button> }/>
                </DataTable>
            )
    
        }

    function hasCancelledQuantityZero() {
        return record_data.some(item => Number(item.cancelled_quantity) === 0);
    }

    async function handleSubmit(e) {
        if(hasCancelledQuantityZero()){
            toast.current.show({severity:'error', detail:'Please enter a valid quantity to cancel the sales order.', life: 20000})
            return
        }

        let endpoint = helpers.createUrl(`V1/manage/order/sales/cancel-items`)
        if(origin === 'invoice' || origin === 'invoices'){
            endpoint = helpers.createUrl(`V1/manage/order/invoices/cancel-items`)
        }
        //const res = await getApiData(endpoint, false)
        const form_data = {
            "id": reference_id,
            "cancelled_items": record_data
        }
        const res = await postApiData(endpoint, form_data, false)

        if(res.status === 'error'){
            toast.current.show({severity:'error', detail:res.message, life: 10000});
            setLoading(0)
        }
        else{
            setLoading(0)
            //toast.current.show({severity:'success', detail:res.message, life: 20000});
            reset();
            setShow(0);
            handleSave(res)
        }
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setRecordData([])
        setNotice('')
    }

    const footerContent = (
        <div>
            <Button label="Proceed" className='rounded' onClick={(e) => handleSubmit(1)} disabled={!is_checked} autoFocus />
        </div>
    );

    return (
        <>
            <Toast ref={toast} position="top-center" />
            <Dialog 
                visible={is_show} 
                position="top" 
                header={header_title} 
                style={{ width: '70vw' }} 
                breakpoints={{ 
                    '960px': '75vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                footer={footerContent}
            >
                <Loader isLoading={loading}/>
                <p>Choose the items and the quantity to be canceled</p>

                <div className='mb-3'>
                {data_table}
                </div>

                <div className="d-flex p-3" style={{backgroundColor: '#fff4e9'}}>
                    <Checkbox inputId="confirmed" checked={is_checked} onChange={e => setChecked(e.checked)} />
                    <label htmlFor="confirmed" className="ml-2 mb-0 font-weight-normal">I understand that once back-ordered items are canceled, they will be dissociated from their respective orders.</label>
                </div>
            </Dialog>
        </>
    )
}